import SearchIcon from '@mui/icons-material/Search';
import React from 'react';

// Shared icons configuration for MaterialTable
// Ensures Search icon uses the theme's primary color and preserves ref forwarding
const SearchIconWithRef = React.forwardRef((props, ref) => (
  <SearchIcon {...props} ref={ref} color="primary" />
));

const materialTableIcons = {
  Search: SearchIconWithRef
};

export default materialTableIcons;
